export default [
	{
		id: 'casabela-operacional',
		name: 'Casabela Operacional',
		type: 'Aplicativo para Tablet',
		service: 'Design e Desenvolvimento',
		description: 'Uma ferramenta tão elegante quanto útil',
		goal: 'O Grupo Casabela é dono da rede de lojas de móveis planejados Italínea e Todeschini. O Centro Operacional de Sorocaba precisava de um aplicativo para facilitar o trabalho da sua equipe de montadores e gestores, incluindo em uma só ferramenta todas as plantas do projeto que a equipe iria instalar na casa dos clientes.',
		result: 'Como todas as plantas são criadas e convertidas para arquivos PDF antes de serem entregues aos montadores em papel, a solução foi criar um sistema onde os gestores poderiam transferir os arquivos para o tablet do montador e o aplicativo pudesse realizar uma busca pelos arquivos dos clientes que teriam seus projetos montados. Por se tratar de uma ferramenta, o aplicativo foi desenvolvido com usabilidade em mente, sem deixar de lado um design simples, intuitivo e elegante.',
		backgroundColor: '#e76747', // f07252
		accentColor: '#a42b2b',
		bannerColor: '#f9b09d',
		img: 'casabela-2.png',
		wideImg: true,
		features: [
			{
				title: 'Visualizador de PDF para mostrar os detalhes que impressão nenhuma consegue',
				description: 'Trabalhando com arquivos em PDF, o montador pode dar zoom em um detalhe e conseguir enxerga-lo sem perder nenhuma qualidade na imagem.',
				img: 'casabela-1.png',
				wideImg: true,
				color: '#f9b09d'
			},
			{
				title: 'Pesquisa por plantas de cada cliente',
				description: 'Barra de pesquisas que possibilita encontrar todos os arquivos relacionados ao termo de busca.',
				img: 'casabela-2.png',
				wideImg: true,
				color: '#f9b09d'
			},
			{
				title: 'Troca fácil entre arquivos pesquisados',
				description: 'A um clique de distância, é possível navegar entre os arquivos pesquisados sem abrir a barra de tarefas.',
				img: 'casabela-5.png',
				wideImg: true,
				color: '#f9b09d'
			},
			{
				title: 'Descanso de tela para o cliente conhecer sua equipe de montadores',
				description: 'Quando o tablet está em inatividade por um certo tempo, um descanso de tela aparece, mostrando um slide show com as informações da equipe que está montando seu projeto.',
				img: 'casabela-4.png',
				wideImg: true,
				color: '#f9b09d'
			},
		],
	},
	{
		id: 'ser-arvore-app',
		name: 'Ser Árvore',
		type: 'Aplicativo Móvel',
		service: 'Design e Desenvolvimento',
		description: 'Colha suas sementes motivacionais',
		goal: 'Luiz Brites é autor do livro Ser Árvore, obra que usa de metáforas da natureza para ensinar seus leitores a como ter uma vida mais leve e de maior qualidade. Luiz queria um aplicativo que pudesse enviar diariamente sementes de novas possibilidades para seus usuários na forma de notificações.',
		result: 'O aplicativo é simples e leve, mas carrega um enorme poder de ajudar seus usuários em suas vidas. Cada semente de possibilidades é uma imagem com uma citação do livro, que pode ser salva no aplicativo por meio do botão de favoritos. O app também conta com um espaço para quem quer saber mais sobre o livro Ser Árvore e para quem quer ficar por dentro dos eventos de seu autor.',
		backgroundColor: '#85e747', 
		accentColor: '#23631e',
		bannerColor: '#d0f9a7',
		img: 'ser-arvore-3.jpg',
		wideImg: false,
		features: [
			{
				title: 'Receba mensagens motivacionais diariamente',
				description: 'Baseadas nas metáforas do livro de Luiz, as imagens contendo mensagens motivacionais são entregues aos usuários todos os dias pela manhã.',
				img: 'ser-arvore-1.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
			{
				title: 'Guarde suas sementes favoritas',
				description: 'O usuário pode salvar suas mensagens motivacionais em seus favoritos para poder vê-las novamente quando quiser.',
				img: 'ser-arvore-2.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
			{
				title: 'Fique por dentro das novidades e colha suas sementes',
				description: 'Na tela inicial existe um espaço para banners dos eventos do Luiz e também mais algumas mensagens que o usuário pode encontrar a qualquer momento.',
				img: 'ser-arvore-3.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
			{
				title: 'Saiba mais sobre o livro',
				description: 'Caso você queira se informar mais sobre Ser Árvore.',
				img: 'ser-arvore-4.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
		],
		links: [
			{
				type: 'ios',
				url: 'https://itunes.apple.com/us/app/ser-%C3%A1rvore/id1337010671?mt=8'
			},
			{
				type: 'android',
				url: 'https://play.google.com/store/apps/details?id=com.serarvore'
			}
		]
	}
] 


// WEBPACK FOOTER //
// ./src/values/projects/projects-br.js